import { render, staticRenderFns } from "./CallCenterChart.vue?vue&type=template&id=72b6ff03&"
import script from "./CallCenterChart.vue?vue&type=script&lang=js&"
export * from "./CallCenterChart.vue?vue&type=script&lang=js&"
import style0 from "./CallCenterChart.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
